import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { errorsMapping } from "../../../../constants/constants/constants.js";
import { GET_ORDER_BY_TOKEN } from "../../../../operations/queries/operations/queries/get-order-by-token.js";
const useGetOrderByToken = () => {
  const [orderByToken, { called, loading, data, error }] = useLazyQuery(GET_ORDER_BY_TOKEN, {
    onError(error2) {
      console.error(error2);
      toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }
  });
  const getOrderByToken = React.useCallback(
    async (token, onCompleted) => {
      if (token) {
        const result = await orderByToken({ variables: { token } });
        if (result.data !== null) {
          onCompleted();
        }
      }
    },
    [orderByToken]
  );
  const queryResults = React.useMemo(
    () => ({
      data: data || void 0,
      called,
      loading,
      error
    }),
    [called, data, error, loading]
  );
  return [getOrderByToken, queryResults];
};
export {
  useGetOrderByToken
};
//# sourceMappingURL=use-get-order-by-token.js.map
